import script from "./signature.vue?vue&type=script&setup=true&lang=ts"
export * from "./signature.vue?vue&type=script&setup=true&lang=ts"

import "./signature.vue?vue&type=style&index=0&id=01582805&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01582805"]])

export default __exports__